const pickerElem = document.querySelector('.picker');
if (pickerElem) {
  const ticketPlaceholder = document.querySelector('.picker__item--ticket .picker__button-placeholder');
  const datepickerPlaceholder = document.querySelector('.picker__item--datepicker .picker__button-placeholder');
  const guestsPlaceholder = document.querySelector('.picker__item--guests .picker__button-placeholder');
  // ------
  // Toggle Overlay
  // ------

  const toggleOverlay = (toggle) => {
    document.body.classList.toggle('overlay-visible', toggle);
    toggleBodyScrollLock(toggle);
  };

  // ------
  // Toggle Dropdown
  // ------

  const togglePickerDropdown = (element, toggle) => {
    element.classList.toggle('is-active', toggle);
  };

  // ------
  // Close other dropdown
  // ------
  const pickerItems = document.querySelectorAll('.picker__item');

  const closeOtherDropdowns = () => {
    pickerItems.forEach((item) => {
      item.classList.remove('is-active');
    });
  };

  // ------
  // Add Disabled Class dropdown
  // ------

  const addDisabledDropdownClass = () => {
    pickerItems.forEach((item) => {
      item.classList.add('is-disabled');
    });
  };

  // ------
  // Open Dropdown
  // ------

  attachEvent('.picker__button', 'click', (ev) => {
    const parentElem = ev.target.closest('.picker__item');
    const isOpen = parentElem.classList.contains('is-active');

    if (isOpen) {
      closeOtherDropdowns();
    } else {
      closeOtherDropdowns();
      togglePickerDropdown(parentElem, true);
    }

    toggleOverlay(!isOpen);
    ev.preventDefault();
  });

  attachEvent('.picker__overlay', 'click', () => {
    closeOtherDropdowns();
    toggleOverlay(false);
    pickerElem.classList.remove('is-open');
  });

  // ------
  // Close Dropdowns Escape Key Press
  // ------

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOtherDropdowns();
      toggleOverlay(false);
    }
  });

  // ------
  // Open Picker - Mobile
  // ------

  const selectTicketElem = document.querySelector('.picker__item--ticket');

  const togglePicker = (toggle) => {
    pickerElem.classList.toggle('is-open', toggle);
    selectTicketElem.classList.add('is-active');
    toggleOverlay(toggle);
  };

  attachEvent('.picker__mobile-trigger', 'click', (ev) => {
    togglePicker(true);
    ev.preventDefault();
  });

  // ------
  // Close Picker - Mobile
  // ------

  attachEvent('.picker__close-btn, .language-dropdown__placeholder', 'click', (ev) => {
    togglePicker(false);
    closeOtherDropdowns();
    ev.preventDefault();
  });

  // ------
  // Submit Header Picker form
  // ------
  attachEvent('.btn--picker-search-button, .picker__submit .btn--default, .btn--confirm-selection', 'click', (e) => {
    e.preventDefault();
    const formData = {};
    document.querySelectorAll('.picker__form input').forEach((input) => {
      if (input.type === 'text') {
        formData[input.name] = input.value.trim();
      } else if (input.type === 'radio' && input.checked) {
        formData[input.name] = input.value.trim();
      } else if (input.type === 'checkbox' && input.checked) {
        formData[input.name] = input.value.trim();
      }
    });
    const date = new Date(new Date(mobiscrollEl.getVal()));
    const formattedDate = date
      .toLocaleString('sl-si', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(/ /g, '');

    formData.s = document.querySelector('#flexi-date').classList.contains('is-active') ? 'flex' : formattedDate;
    const searchParams = new URLSearchParams(formData);
    const urlEncodedString = searchParams.toString();
    window.location = localData.reservationURL + urlEncodedString;
  });

  // ------
  // Reset Header Picker form
  // ------

  const defaultTicketPlaceholderText = ticketPlaceholder.innerHTML;
  const defaultDatePlaceholderText = datepickerPlaceholder.innerHTML;
  const defaultGuestsPlaceholderText = guestsPlaceholder.innerHTML;
  const pickerReset = document.querySelector('.picker__reset');
  if (pickerReset) {
    pickerReset.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('.counter__input').forEach((input, key) => {
        // eslint-disable-next-line no-param-reassign
        input.value = key === 0 ? 2 : 0;
      });
      document.querySelectorAll('.picker__dropdown--ticket input').forEach((input) => {
        // eslint-disable-next-line no-param-reassign
        input.checked = false;
      });
      mobiscrollEl.setVal(new Date());
      mobiscrollEl.setOptions({
        labels: [],
      });

      // Replace Placeholder Text With Default
      ticketPlaceholder.innerHTML = defaultTicketPlaceholderText;
      datepickerPlaceholder.innerHTML = defaultDatePlaceholderText;
      guestsPlaceholder.innerHTML = defaultGuestsPlaceholderText;

      // Close All Dropdown and Added Disabled Class
      closeOtherDropdowns();
      addDisabledDropdownClass();

      // Active First Item, Open Dropdown and Remove Disabled Class
      const ticketItem = document.querySelector('.picker__item--ticket');
      ticketItem.classList.add('is-active');
      ticketItem.classList.remove('is-disabled');
    });
  }

  // ------
  // Open Picker - Steps
  // ------

  const ticketInputs = document.querySelectorAll('.picker__form input');
  const dateEleButton = document.querySelector('.date-picker .btn');

  const nextStepActive = (ele) => {
    const parentEle = ele.target.closest('.picker__item');
    const nextStep = parentEle.nextElementSibling;
    parentEle.classList.remove('is-active');
    nextStep.classList.add('is-active');
    nextStep.classList.remove('is-disabled');
  };

  ticketInputs.forEach((el) => {
    el.addEventListener('change', (ev) => {
      nextStepActive(ev);
    });
    el.addEventListener('click', (ev) => {
      nextStepActive(ev);
    });
  });

  if (dateEleButton) {
    dateEleButton.addEventListener('click', (ev) => {
      nextStepActive(ev);
    });
  }

  attachEvent('.btn--confirm-selection, .btn--picker-search-button', 'click', (ev) => {
    const parentEle = ev.target.closest('.picker__item');
    parentEle.classList.remove('is-active');
    closeOtherDropdowns();
    toggleOverlay(false);
    pickerElem.classList.remove('is-open');
    ev.preventDefault();
  });

  // ------
  // Selected Item Replace With Placeholder
  // ------

  // Total Guests
  const counterSum = (ele) => {
    const parentEle = ele.target.closest('.picker__item--guests');
    const inputEle = parentEle.querySelectorAll('.counter__input');
    guestsPlaceholder.innerHTML = Array.from(inputEle).reduce((sum, input) => sum + parseFloat(input.value), 0);
  };

  // Ticket
  ticketInputs.forEach((el) => {
    el.addEventListener('change', (ev) => {
      const parentEle = ev.target.closest('.picker__dropdown-item');
      ticketPlaceholder.innerHTML = parentEle.querySelector('.picker__dropdown-item-title').innerHTML;
    });
  });

  // Date
  mobiscrollEl.setOptions({
    onCellClick: (event) => {
      const formattedDate = event.date.toLocaleString('sl-si', { year: 'numeric', month: '2-digit', day: '2-digit' });
      datepickerPlaceholder.innerHTML = formattedDate;
      nextStepActive(event);
    },
  });

  attachEvent('.picker__dropdown--datepicker .btn', 'click', () => {
    datepickerPlaceholder.innerHTML = 'Flex';
  });

  // Counter
  attachEvent('.picker__item--guests .counter__button--add', 'click', counterSum);
  attachEvent('.picker__item--guests .counter__button--remove', 'click', counterSum);

  // ------
  // Open last enabled item
  // ------
  attachEvent('.picker__item.is-disabled', 'click', () => {
    const items = document.querySelectorAll('.picker__item:not(.is-disabled)');
    const lastItem = items.length - 1;
    items[lastItem].classList.add('is-active');
  });

  // ------
  // Hold Picker Value
  // ------
  document.addEventListener('DOMContentLoaded', () => {
    const { search } = new URL(window.location.href);
    const params = new URLSearchParams(search);

    const types = params.get('types');
    const adults = params.get('adults');
    const children = params.get('children');
    const date = params.get('s');

    if (types || adults || children || date) {
      if (types) {
        ticketInputs.forEach((input) => {
          if (input.id === types) {
            // eslint-disable-next-line no-param-reassign
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      // Date
      if (date) {
        if (date === 'flex') {
          datepickerPlaceholder.innerHTML = 'Flex';
        } else {
          const [day, month, year] = date.split('.');
          const selectedDate = new Date(`${year}-${month}-${day}`);
          const formattedDate = selectedDate.toLocaleString('sl-si', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          });
          mobiscrollEl.setVal(selectedDate);
          datepickerPlaceholder.innerHTML = formattedDate;
        }
      }

      // Guests
      if (adults || children) {
        const counterInput = document.querySelectorAll('.picker__item--guests .counter__input');
        counterInput.forEach((input) => {
          const matchedInput = input;
          const parentEle = matchedInput.closest('.picker');
          const counterEle = parentEle.querySelectorAll('.counter');

          matchedInput.value = matchedInput.id === 'adults' ? adults : children;

          counterEle.forEach((ele) => {
            const minusButton = ele.querySelector('.counter__button--remove');
            const counterInputEle = ele.querySelector('input');

            if (counterInputEle.value >= 1) {
              minusButton.classList.remove('is-disabled');
            }
          });
        });

        const sum = Array.from(counterInput).reduce((total, input) => total + parseFloat(input.value || 0), 0);
        guestsPlaceholder.innerHTML = sum;
      }

      // Remove Active Items / Dropdown
      closeOtherDropdowns();

      pickerItems.forEach((item) => {
        item.classList.remove('is-disabled');
      });
    }
    // Hide children radio for sauna
    document.querySelector('.picker__form #children').closest('.picker__guest-item').hidden =
      document.querySelector('.picker__form input#saunas').checked;
  });
}
